import { axiosClient } from "./axiosClient"

export const PURCHASE_PATH = '/api/v1/purchase'

export const addPurchase = (body) => {
    return axiosClient.post(PURCHASE_PATH, body)
}

export const getPagePurchases = ({ search = "", lastId = '', id = "", supplierId = "", invoiceNumber = '' }) => {
    return axiosClient.get(`${PURCHASE_PATH}/page?search=${search}&lastId=${lastId}&id=${id}&supplierId=${supplierId}&invoiceNumber=${invoiceNumber}`)
}

export const deletePurchase = (id) => {
    return axiosClient.delete(`${PURCHASE_PATH}/${id}`)
}

export const getPurchaseById = (id) => {
    return axiosClient.get(`${PURCHASE_PATH}/${id}`)
}

export const updatePurchase = (id, body) => {
    return axiosClient.put(`${PURCHASE_PATH}/${id}`, body)
}

export const addPurchaseCost = (id) => {
    return axiosClient.put(`${PURCHASE_PATH}/add-cost/${id}`)
}

export const removePurchaseCost = (id) => {
    return axiosClient.put(`${PURCHASE_PATH}/remove-cost/${id}`)
}

export const downloadPurchaseReceipt = (id) => {
    return axiosClient.get(`${PURCHASE_PATH}/download-receipt/${id}`, {
        responseType: 'arraybuffer',
    })
}

export const uploadPurchaseExcelFile = (body) => {
    return axiosClient.post(`${PURCHASE_PATH}/upload-excel`, body)
}